var _path, _path2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilesPdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 124,
    viewBox: "0 0 102 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 4L100 44V110C100 117.732 93.732 124 86 124H14C6.26801 124 0 117.732 0 110V18C0 10.268 6.26801 4 14 4H60Z",
    fill: "#E94848"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.6333 48C44.0116 48 41.8556 50.1561 41.8556 52.7778C41.8556 56.0369 43.6664 60.0831 45.5733 63.8861C44.0827 68.552 42.3913 73.5522 40.2281 77.7715C39.4446 78.079 38.6761 78.3724 37.9286 78.6578C34.4524 79.9853 31.432 81.1387 29.4781 82.7135C29.4411 82.7514 29.4062 82.7913 29.3736 82.833C28.5061 83.7201 28 84.928 28 86.2222C28 88.8439 30.1561 91 32.7778 91C34.0562 91 35.2902 90.5229 36.1819 89.6115C36.2128 89.5878 36.2427 89.5629 36.2715 89.5368C38.019 87.4502 40.0794 83.665 41.9153 80.2052C46.1464 78.5408 50.5809 76.8472 54.8601 75.8306C57.9839 78.3481 62.5031 80.0111 66.2222 80.0111C68.8439 80.0111 71 77.855 71 75.2333C71 72.6116 68.8439 70.4556 66.2222 70.4556C63.2397 70.4556 58.9056 71.5202 55.5917 72.6354C52.9056 70.1138 50.4377 66.9644 48.6639 63.6174C48.8555 63.0271 49.052 62.4368 49.2475 61.8494L49.2477 61.8487L49.2478 61.8484L49.2479 61.8481C50.3452 58.5512 51.4111 55.3484 51.4111 52.7778C51.4111 50.1561 49.2551 48 46.6333 48ZM46.6333 50.8667C47.7058 50.8667 48.5444 51.7053 48.5444 52.7778C48.5444 54.2118 47.7765 56.852 46.8872 59.6906C45.6987 56.9292 44.7222 54.2798 44.7222 52.7778C44.7222 51.7053 45.5609 50.8667 46.6333 50.8667ZM52.4115 73.5163C50.5745 71.6283 48.8915 69.5014 47.4545 67.2156C46.455 70.2574 45.3991 73.3464 44.0802 76.3233C46.811 75.2838 49.5781 74.2911 52.4115 73.5163ZM66.2222 73.3222C67.2947 73.3222 68.1333 74.1609 68.1333 75.2333C68.1333 76.3058 67.2947 77.1444 66.2222 77.1444C64.0692 77.1444 61.0091 76.1725 58.5628 74.8153C61.3708 74.0213 64.4347 73.3222 66.2222 73.3222ZM34.0917 87.6406C35.0258 86.5142 36.3613 84.2757 37.7049 81.8774C34.9335 82.9866 32.4951 84.026 31.3743 84.8934C31.0812 85.2163 30.8667 85.7175 30.8667 86.2222C30.8667 87.2946 31.7053 88.1333 32.7778 88.1333C33.3481 88.1333 33.7726 87.9457 34.0917 87.6406Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_44)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100 44H74.7071C66.9751 44 60 37.0249 60 29.2929V4L100 44Z",
    fill: "white",
    fillOpacity: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_44",
    x: 58,
    y: 0,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0909637 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_44"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_44",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilesPdf);
export default __webpack_public_path__ + "static/media/files-PDF.cd5e5b8197426827c43785527346898d.svg";
export { ForwardRef as ReactComponent };